import React from 'react';
import Notifications from '../Notifications';
import { INotificationsContext } from '../Notifications/context';
import Dialogs from '../Dialogs';
import UI from '.';
import create from 'zustand';

interface UIWrapperProps {
  children: React.ReactNode;
  portal?: HTMLElement;
}

// TODO: rename to something more "singleton" like.
interface INotificationStore {
  singleton: HTMLDivElement;
  setSingleton: (singleton: HTMLDivElement) => void;
}

const [useNotificationsStore] = create<INotificationStore>(set => ({
  singleton: null,
  setSingleton: singleton =>
    set(state => {
      if (!state.singleton) {
        return {
          singleton,
        };
      } else {
        return {
          singleton: state.singleton,
        };
      }
    }),
}));

// FIXME: this would not be needed if we correctly used Zustand - access notifications store directly (see dialogs store usages in UI)
export function UIWrapperWithSingleton({ children, portal }: UIWrapperProps): React.ReactElement {
  const singleton = useNotificationsStore(state => state.singleton);
  const setSingleton = useNotificationsStore(state => state.setSingleton);
  const notificationsRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!singleton) {
      setSingleton(notificationsRef.current);
    }
  }, [notificationsRef.current, singleton]);

  function handleNotificationsReady(context: INotificationsContext) {
    // register notification store with the UIManager
    UI.notificationContext = context;
  }

  return (
    <>
      {children}
      {(!singleton || (singleton && notificationsRef.current === singleton)) && (
        <>
          <Notifications ref={notificationsRef} onReady={handleNotificationsReady} portal={portal} />
          <Dialogs /*portal={portal}*/ />
        </>
      )}
    </>
  );
}

export default function UIWrapper({ children, portal }: UIWrapperProps): React.ReactElement {
  function handleNotificationsReady(context: INotificationsContext) {
    // register notification store with the UIManager
    UI.notificationContext = context;
  }

  return (
    <>
      {children}
      <Notifications onReady={handleNotificationsReady} portal={portal} />
      <Dialogs /*portal={portal}*/ />
    </>
  );
}
